<!-- 打印方案 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :showRefresh="true" :buttonFlag="false"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
                    <el-form-item>
                        <label slot="label" :style="$common.labelStyle('模块')" v-html="$common.htmlLabel('模块')"></label>
                        <el-cascader style="width: 400px;" :options="systemFormList" placeholder="请选择要操作的表单"
                            :props="{ expandTrigger: 'hover' }" size="medium " v-model="selectForm" :filterable="true"
                            clearable @change="getDataList">
                            <template slot-scope="{ node, data }">
                                <span>{{ data.label }}</span>
                                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                            </template>
                        </el-cascader>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum"
                border style="width: 100%" highlight-current-row>
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="printName" label="方案名称"></el-table-column>
                <el-table-column prop="printDesc" label="说明"></el-table-column>
            </el-table>
        </div>
        <!-- <div class="page_content_bottom">
      <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30" layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
      </el-pagination>
    </div> -->
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth"
                @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-drawer :close-on-press-escape="true" :visible.sync="dialogFormVisible" :with-header="false"
            append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
                    <v-tabs :type="operType" :activeName="drawerTitle" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { drawerTitle = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box" v-if="scope.index == 0">
                                <!-- 主要信息 -->
                                <el-form ref="sendDataInfo" :model="printform" inline size="mini" :show-message="false"
                                    label-width="150px" :rules="rules">
                                    <el-form-item label="方案名称" prop="printName">
                                        <el-input v-model="printform.printName" autocomplete="off" clearable></el-input>
                                    </el-form-item>
                                    <el-form-item label="方案说明" prop="printDesc">
                                        <el-input v-model="printform.printDesc" autocomplete="off" type="textarea"
                                            clearable></el-input>
                                    </el-form-item>
                                    <el-button type="primary" @click="printDesign" plain>模板设计</el-button>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>

                <div style="text-align:center; margin-top:20px;">
                    <el-button v-if="operType != 2" type="primary" @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirm('sendDataInfo')" v-if="operType == 0">保存</el-button>
                    <el-button type="primary" @click="confirm('sendDataInfo')" v-if="operType == 1">保存</el-button>
                </div>

            </div>

        </el-drawer>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import Vue from 'vue'
import {
    getPrintDataById,
    addPrintPlan,
    updatePrintPlan,
    delPrintPlan,
    queryPrintCount,
} from "@/service/printApi.js";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            tabForm: [],
            getRequestData: {
                contact: "",  //	联系人
                unit: "",   //单位
                ormId: "",
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            rules: {
                printName: [
                    { required: true, message: '请输入方案名称', trigger: 'blur' }
                ]
            },
            buttonList: [],
            selectForm: "",
            pageShowData: [],
            selectedDataIndex: 0,
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: "0",
            seId: 0,
            mxHeight: 0,
            dialogFormVisible: false,
            formData: {},
            printform: {
                printName: '',
                printDesc: '',
                printContent: ''
            },
            systemFormList: [],
            userData: [],
            ids: [],
            allDataList: [],
            printDataUrl: '',
            operType: 0,
            reportmod: '',
            drawerTitle: "",
            token: "",

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.opmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.opmId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        time() {
            var time = Math.round(new Date() / 1000);
            return time
        },
        // 新增方案
        confirm(printform) {
            let printContentData = ""
            if (this.printform.printName == '') return this.$message({
                message: '请填写方案名称',
                type: 'warning'
            });

            if (Vue.prototype.$printReportMod == '') return this.$message({
                message: '请先进行模板设计',
                type: 'warning'
            });

            let params = {
                jurId: this.selectForm[1],
                printContent: Vue.prototype.$printReportMod,
                printDesc: this.printform.printDesc,
                printName: this.printform.printName,
                printId: this.printform.printId
            }
            if (this.operType == 0) {
                addPrintPlan(params, this.token).then((res) => {
                    if (res.status === 200) {
                        this.dialogFormVisible = false
                        this.$message({
                            message: '新增成功',
                            type: 'success'
                        });
                        this.getPrintPlanById(this.idParams)
                        // this.userData = res.result
                    }
                });
            } else {
                updatePrintPlan(params, this.token).then((res) => {
                    if (res.status === 200) {
                        this.dialogFormVisible = false
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.getPrintPlanById(this.idParams)
                        // this.userData = res.result
                    }
                });
            }

        },
        printDesign() {
            if (this.printform.printName == '') return this.$message({
                message: '请填写方案名称',
                type: 'warning'
            });
            // console.log('printDesign',this.printform, this.printform.printName);
            this.$printSocketApi.designReport(this.userData, this.reportmod, this.printform.printName)
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index) {
            this.focusIndex = index;
            this.DialogVisible = true;
            this.seId = sId;
        },
        //检索带回数据
        changeInputModel(val) {
            console.log("返hui", val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false; //关闭商品检索窗口
                //赋值给当前行
                if (val.opmId) {
                    this.getRequestData.opmId = val.opmId;
                    this.getRequestData.opmName = val.opmName;
                }
            } else {
                this.DialogVisible = false;
                this.$message({
                    message: "检索失败",
                    type: "error",
                });
            }
            console.log("检索返后", this.sendDataInfo);
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");

                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.bgmId = dataInfo.bgmId;
                        this.getRequestData.bgmName = dataInfo.bgmName;
                    }

                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId],
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList
                this.getDataList();
                this.getButtonList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    Vue.prototype.$printReportKey = this.time()
                    this.formData = {}
                    this.operType = 0
                    this.init()
                    this.drawerTitle = "新增";
                    this.dialogFormVisible = true;
                    this.tabForm = [
                        {
                            jciName: this.drawerTitle + '打印方案',
                            jurconfigform: []
                        }
                    ]
                    break;
                case 1:
                    if (this.returnData.list.length <= 0) {
                        if (!dataInfo) {
                            this.$message({
                                message: "暂无数据",
                                type: "error",
                            });
                            return false;
                        }
                    }
                    if (!this.returnData.list[this.selectedDataIndex]) {
                        this.$message({
                            message: "请先选择您要操作的数据",
                            type: "error",
                        });
                        return false;
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex];
                    this.drawerTitle = "修改";
                    this.operType = 1
                    this.printform = dataInfo
                    this.tabForm = [
                        {
                            jciName: this.drawerTitle + '打印方案',
                            jurconfigform: []
                        }
                    ]
                    this.reportmod = dataInfo.printContent
                    this.dialogFormVisible = true;
                    break;
                case 2:
                    this.delDataAction();
                    break;
                case 3:
                    this.submitData();
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        init() {
            for (let key in this.printform) {
                this.printform[key] = ''
            }
            this.$printReportMod = ''
            this.reportmod = ''
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getInterceptRoules(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                // this.returnData.pages = responseData.result.pages;
                // this.returnData.total = responseData.result.total;
                // this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 删除数据
        delDataAction() {
            if (this.returnData.list.length <= 0) {
                if (!dataInfo) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
            }
            if (!this.returnData.list[this.selectedDataIndex]) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [dataInfo.printId],
                    };
                    let responseData = await delPrintPlan(delData, this.token);
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });

                        this.getDataList();
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                })
                .catch(() => { });
        },
        // 获取检索ID
        getDataList() {
            console.log('getDataList', JSON.parse(JSON.stringify(this.selectForm)));
            this.ids[0] = this.selectForm[1];
            this.idParams = {
                ids: this.ids,
            };
            this.getPrintPlanById(this.idParams)
            this.allDataList.forEach(item => {
                if (this.selectForm[1] == item.jurId) {
                    this.printDataUrl = item.printSource
                    this.getPrintDataById()
                }
            })
        },
        // 通过ID获取打印方案模拟数据
        getPrintDataById() {
            let params = {
                id: '',
                isPrint: 0
            }
            getPrintDataById(params, this.printDataUrl, this.token).then((res) => {
                if (res.status === 200) {
                    this.userData = res.result
                }
            });
        },
        // 通过ID获取检索方案
        getPrintPlanById(params) {
            this.loading = true
            this.$http.getPrintPlanById(params).then((responseData) => {
                if (responseData.status === 200) {
                    this.returnData.list = responseData.result;
                    // this.returnData.list = responseData.result.list;
                    // this.returnData.pages = responseData.result.pages;
                    // this.returnData.total = responseData.result.total;
                    // this.returnData.pageNum = responseData.result.pageNum;
                    this.selectedDataIndex = 0;
                    this.loading = false
                }
            });
        },
        getAllPrintPlan() {
            return new Promise((resolve, reject) => {
                this.$http.getPrintPlan().then((res) => {
                    console.log('getAllPrintPlan', res);
                    this.allDataList = res.result
                    let arr = res.result
                    arr.forEach((itemValue, itemKey) => {
                        if (itemValue.jurStype == 1) {
                            var sendDataOne = {
                                value: itemValue.jurId,
                                label: itemValue.jurName,
                                children: [],
                            }
                            this.systemFormList.push(sendDataOne)
                        }
                    })

                    this.systemFormList.forEach((listOne, listKey) => {
                        arr.forEach((itemValue, itemKey) => {
                            if (itemValue.jurParentid == listOne.value) {
                                var sendDataOne = {
                                    value: itemValue.jurId,
                                    label: itemValue.jurName,
                                }
                                this.systemFormList[listKey].children.push(sendDataOne)
                            }
                        })
                    })
                    this.systemFormList.forEach(item=>{
                        if (!item.children||item.children.length==0) {
                            delete item.children
                        }
                    })
                    resolve();
                });
            });
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getButtonList();
        this.token = sessionStorage.getItem("token");
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getAllPrintPlan()
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>